import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import api from "../src/api/user"

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== "production";

// #1124 : matrice des droits des profils, gardée entre deux rechargements de page
function permissionsSauvegardees() {
    try {
        return JSON.parse(localStorage.getItem("crm-permissions")) || null;
    } catch (e) {
        return null;
    }
}
export default new Vuex.Store({

    state: {
        user: {},
        permissions: permissionsSauvegardees(),
        token: localStorage.getItem("user-token") || "",
        AsUser: { nom: '', id_utilisateur: '' },
        currentTab: 0,
        entreprise: {
            raison_sociale: "",
            actif: true,
            code_fta: "",
            type_client: ""
        },
        notification: {
            show: false,
            message: "",
            type: "error",
        },
        backendDown: false,
    },
    mutations: {
        setNotification(state, { message, type = "error" }) {
            state.notification = { show: true, message, type };
        },
        clearNotification(state) {
            state.notification.show = false;
        },
        setBackendDown(state, value) {
            state.backendDown = value;
        },

        infosUser: (state, resp) => {
            state.status = "logged";
            // enregistrement du user dans le state
            state.user = resp.user;
            if (resp.permissions) {
                state.permissions = resp.permissions;
                try {
                    localStorage.setItem("crm-permissions", JSON.stringify(resp.permissions));
                } catch (e) {
                    // stockage indisponible : la matrice reste en mémoire pour la session
                }
            }
            // stocker dans le local storage le token
            localStorage.setItem("user-token", resp.token);
            localStorage.userToken = JSON.stringify(resp.token);
            axios.defaults.headers.common = { 'Authorization': `Bearer ${resp.token}` }


        },
        connectedAs(state, user) {
            state.AsUser = user

        },
        changeOnglet(state, value) {
            state.currentTab = value;
        },
        upadateActifEntreprise(state, value) {
            state.entreprise.actif = value
        },
        upadateCodeFtaEntreprise(state, value) {
            state.entreprise.code_fta = value
        },
        updateTypeClientEntreprise(state, value) {
            state.entreprise.type_client = value
        }
    },
    actions: {
        notify({ commit }, { message, type = "error" }) {
            commit("setNotification", { message, type });
        },
        isAuthenticated: ({ commit }) => {
            axios.defaults.headers.common = { 'Authorization': `Bearer ${localStorage.getItem("user-token")}` }
            api.isauthenticated().then(res => {
                if (res.status == 200) {
                    commit('infosUser', res.data.data)
                }
            })
        }
    }

})


// on peux supprimer pour moi les dossiers actions,modules et creer un dossier api dans src et y mettre le fichier situé dans utils api.js


